import './BettingPart.scss'
import { betStore, gameStore, roundStore, userStore, useTranslation } from '../../platform/stores';
import { observer } from 'mobx-react';
import { ChangeEvent } from 'react';
import { isMobile, isNumeric } from '../../platform/utils';
import { betService } from '../../platform/services';
import { RoundStatus } from '../../platform/enums/round-status';
import { keypadStore } from '../../platform/stores/keypadStore';

export const BettingPart = observer(() => {
  const t = useTranslation();
  const { setBetAmount, doBet, updateBet } = betService;
  const { balance } = userStore;
  const { maxBetAmount, quickBets } = gameStore;
  const { betToEdit } = betStore;
  const { roundStatus } = roundStore;
  const quickBetsToShow = quickBets.slice(0, 2);

  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!isNumeric(event.target.value))
      return;

    setBetAmount(+(+event.target.value).toFixed(2));
  }

  const plusToAmount = (amount: number) => {
    setBetAmount(betStore.amount + amount);
  };

  const doBetOrSave = () => {
    if (betToEdit) {
      updateBet();
    } else {
      doBet();
    }
  }

  const checkAndOpenKeypad = () => {
    if (isMobile()) {
      keypadStore.setText(betStore.amount.toString());
      keypadStore.setOpened(true, setBetAmount);
    }
  }

  return (
    <div className="betting-part-component">
      <div className="inputs">
        <div className="section">
          <div className="amount">
            <div className="minus-button cursor-pointer" onClick={() => plusToAmount(-10)}></div>
            <div className="plus-button cursor-pointer" onClick={() => plusToAmount(10)}></div>
            <input type="number"
                   readOnly={isMobile()}
                   value={betStore.amount}
                   onClick={() => checkAndOpenKeypad()}
                   onChange={(event) => onInputChange(event)}
            />
          </div>
          <div className="secondary-button flex-center" onClick={() => plusToAmount(betStore.amount)}>x2</div>
        </div>
        <div className="section mobile-hidden">
          {
            quickBetsToShow.map((item) =>
              <div className="secondary-button flex-center" key={item} onClick={() => plusToAmount(item)}>+{item}</div>
            )
          }
          <div className="secondary-button flex-center" onClick={() => setBetAmount(maxBetAmount)}>{t('MAX')}</div>
          <div className="secondary-button flex-center" onClick={() => setBetAmount(balance)}>{t('ALL_IN')}</div>
        </div>
      </div>
      <div className={`bet-button flex-center ${roundStatus !== RoundStatus.Started ? 'disabled' : ''}`} onClick={() => doBetOrSave()}>
        {
          betToEdit ? t('SAVE') : t('BET')
        }
      </div>
    </div>
  );
});
